import { Link, useParams } from 'react-router-dom'
import { Calendar, ChevronLeft, Tag, User } from 'lucide-react'
import { Button, Card, CardContent } from '@/components/ui'
import { getBlogPostBySlug } from '@/data/blog'

export function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>()
  const post = slug ? getBlogPostBySlug(slug) : undefined

  if (!post) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="container-page py-16">
          <Card className="max-w-xl mx-auto text-center">
            <CardContent className="py-10">
              <h1 className="text-2xl font-bold text-gray-900">Post not found</h1>
              <p className="mt-2 text-gray-600">
                We couldn’t find that post. Try browsing all posts.
              </p>
              <Link to="/blog" className="inline-block mt-6">
                <Button>Back to Blog</Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container-page py-8">
        <div className="mb-6">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900">
            <ChevronLeft className="h-4 w-4" />
            Back to Blog
          </Link>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className={`rounded-xl h-44 w-full bg-gradient-to-r ${post.imagePlaceholder}`} />

          <h1 className="mt-6 text-3xl font-bold text-gray-900">{post.title}</h1>
          <p className="mt-2 text-gray-600">{post.excerpt}</p>

          <div className="mt-4 flex flex-wrap items-center gap-4 text-sm text-gray-600">
            <span className="inline-flex items-center gap-2">
              <User className="h-4 w-4" />
              {post.author.name} · {post.author.role}
            </span>
            <span className="inline-flex items-center gap-2">
              <Calendar className="h-4 w-4" />
              {post.date} · {post.readTime}
            </span>
          </div>

          <div className="mt-4 flex flex-wrap gap-2">
            <span className="badge badge-primary">{post.category}</span>
            {post.tags.map((t) => (
              <span key={t} className="badge bg-gray-100 text-gray-700 inline-flex items-center gap-1">
                <Tag className="h-3.5 w-3.5" />
                {t}
              </span>
            ))}
          </div>

          <Card className="mt-8">
            <CardContent>
              {/* The client’s mock content is HTML. Render it verbatim. */}
              <div
                className="prose prose-gray max-w-none"
                dangerouslySetInnerHTML={{ __html: post.content }}
              />
            </CardContent>
          </Card>

          <div className="mt-10 flex justify-between gap-3">
            <Link to="/blog">
              <Button variant="outline">All posts</Button>
            </Link>
            <Link to="/brands">
              <Button>Browse brands</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

